import {
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Grid,
  GridItem,
  Heading,
  Text,
} from "@chakra-ui/react";
import * as React from "react";
import { useTranslation } from "react-i18next";
import NumberField from "../../../../../../components/NumberField/NumberField";

/**
 * ESG-3927: renders the Scope 2 v2 per-category breakdown (location-based
 * tCO2e per category). The v2 items carry their own label (`consumptionType`)
 * and a single `co2Emissions` value, so this renders them directly rather than
 * matching against org-structure consumption types like the v1 accordion item.
 */
function V2BreakdownAccordionItem({ items }) {
  const { t } = useTranslation("translation", { keyPrefix: "reportsPage" });

  return (
    <AccordionItem>
      {({ isExpanded }) => (
        <>
          <h2>
            <AccordionButton>
              <Box flex="1" textAlign="left">
                <Heading color="esg_gray.200" size="xs">
                  {t("electricityV2Title")}
                </Heading>
              </Box>
              <Text fontSize="sm" mr={2}>
                {isExpanded ? t("buttons.collapse") : t("buttons.expand")}
              </Text>
              <AccordionIcon />
            </AccordionButton>
          </h2>
          <AccordionPanel pt={2} pb={5} overflow="auto">
            <Grid templateColumns="repeat(2, 1fr)" gap={2}>
              <GridItem>
                <Heading marginBlock="1" size="sm">{t("electricityV2Category")}</Heading>
              </GridItem>
              <GridItem>
                <Heading marginBlock="1" align="right" size="sm">{t("electricityV2LocationEmissions")}</Heading>
              </GridItem>
              {items.map((item) => (
                <React.Fragment key={`v2-${item.consumptionType?.code ?? item.id}`}>
                  <GridItem>
                    <Text fontSize="sm"><b>{item.consumptionType?.name ?? item.consumptionType?.code}</b></Text>
                  </GridItem>
                  <GridItem display="flex" justifyContent="end" alignItems="center">
                    <NumberField value={item.co2Emissions} fontWeight="bold" />
                  </GridItem>
                </React.Fragment>
              ))}
            </Grid>
          </AccordionPanel>
        </>
      )}
    </AccordionItem>
  );
}

export default V2BreakdownAccordionItem;
